import IncPageBody from 'components/inc-page/inc-page-body/inc-page-body.component';
import IncPageHeader from 'components/inc-page/inc-page-header/inc-page-header.component';
import IncPageTabPanels from 'components/inc-page/inc-page-tab-panels/inc-page-tab-panels.component';
import { IncPageTabPanelsProvider } from 'components/inc-page/inc-page-tab-panels/inc-page-tab-panels.context';
import { useSetInitialTabAsDefault } from 'components/inc-page/inc-page-tab-panels/inc-page-tab-panels.hooks';
import IncPageTitle from 'components/inc-page/inc-page-title/inc-page-title.component';
import IncPage from 'components/inc-page/inc-page.component';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectUserDetails } from 'redux/user/user.selectors';

const LoyaltyPerformanceReport = () => {
  const { t } = useTranslation();
  const userDetails = useSelector(selectUserDetails);
  const loggedInIsSuperAdmin = userDetails?.isSuperAdmin;
  const loggedInIsClientAdmin = userDetails?.isClientAdmin;

  const tabs = useMemo(
    () =>
      [
        (loggedInIsSuperAdmin || loggedInIsClientAdmin) && {
          label: t(
            'page.loyaltyPerformanceReport.tabs.brandLoyaltyOverview.label',
          ),
          path: 'brandloyaltyoverview',
        },
        {
          label: t(
            'page.loyaltyPerformanceReport.tabs.franchiseLoyaltyOverview.label',
          ),
          path: 'franchiseloyaltyoverview',
        },
        {
          label: t(
            'page.loyaltyPerformanceReport.tabs.locationLoyaltyPerformance.label',
          ),
          path: 'locationloyaltyperformance',
        },
        {
          label: t(
            'page.loyaltyPerformanceReport.tabs.locationLoyaltyTrends.label',
          ),
          path: 'locationloyaltytrends',
        },
        {
          label: t(
            'page.loyaltyPerformanceReport.tabs.loyaltyOfferPerformance.label',
          ),
          path: 'loyaltyofferperformance',
        },
        {
          label: t(
            'page.loyaltyPerformanceReport.tabs.loyaltyOfferTrends.label',
          ),
          path: 'loyaltyoffertrends',
        },
      ].filter(Boolean),
    [loggedInIsSuperAdmin, loggedInIsClientAdmin, t],
  );

  useSetInitialTabAsDefault(tabs);

  return (
    <IncPage>
      <IncPageHeader>
        <IncPageTitle />
      </IncPageHeader>
      <IncPageBody>
        <IncPageTabPanelsProvider
          tabs={tabs}
          options={{ keepSearchParams: true }}
        >
          <IncPageTabPanels />
        </IncPageTabPanelsProvider>
      </IncPageBody>
    </IncPage>
  );
};

export default LoyaltyPerformanceReport;
